// extracted by mini-css-extract-plugin
export var row = "styles-module--row--urg98";
export var column = "styles-module--column--3w3pR";
export var itemWrapper = "styles-module--itemWrapper--jTmPD";
export var itemWrapperHorizontal = "styles-module--itemWrapperHorizontal--3_IW9";
export var description = "styles-module--description--p6_v7";
export var wrapped = "styles-module--wrapped--1vcLq";
export var containerClass = "styles-module--containerClass--2rEaM";
export var ctaContainer = "styles-module--ctaContainer--34-9K";
export var title = "styles-module--title--1-vGy";